import React from 'react'
import { CheckCircle, LucideIcon } from 'lucide-react'

export interface IconOption {
 value: string
 label: string
 icon?: LucideIcon | React.ReactNode
}

interface IconOptionGridProps {
 value: string
 options: IconOption[]
 onChange: (value: string) => void
 name: string
 columns?: 2 | 3 | 4 | 5 | 6
 required?: boolean
 error?: string
}

const gridCols = {
 2: 'grid-cols-2',
 3: 'grid-cols-2 md:grid-cols-3',
 4: 'grid-cols-2 md:grid-cols-3 lg:grid-cols-4',
 5: 'grid-cols-2 md:grid-cols-3 lg:grid-cols-5',
 6: 'grid-cols-2 md:grid-cols-3 lg:grid-cols-6'
}

export const IconOptionGrid: React.FC<IconOptionGridProps> = ({
 value,
 options,
 onChange,
 name,
 columns = 5,
 required = false,
 error
}) => {
 const renderIcon = (icon: LucideIcon | React.ReactNode) => {
 if (!icon) return null
 
 if (React.isValidElement(icon)) {
 return icon
 }
 const Icon = icon as LucideIcon
 return <Icon className="h-6 w-6 mb-2" />
 }

 return (
 <div>
 <div className={`grid ${gridCols[columns]} gap-3`}>
 {options.map((option) => {
 const isSelected = value === option.value

 return (
 <label
 key={option.value}
 className={`relative flex flex-col items-center p-3 border-2 rounded-lg cursor-pointer transition-all ${
 isSelected
 ? 'border-accent bg-accent/5 dark:bg-primary-900/20 shadow-sm'
 : 'border-border hover:border-border dark:hover:border-gray-600'
 }`}
 >
 <input
 type="radio"
 name={name}
 value={option.value}
 checked={isSelected}
 onChange={(e) => onChange(e.target.value)}
 className="sr-only"
 required={required}
 />
 
 {/* Ícone */}
 <div className={isSelected 
 ? 'text-accent dark:text-accent' 
 : 'text-muted-foreground'
 }>
 {renderIcon(option.icon)}
 </div>
 
 {/* Label */}
 <span className={`text-xs font-medium text-center ${
 isSelected
 ? 'text-primary-700 dark:text-primary-300'
 : 'text-muted-foreground'
 }`}>
 {option.label}
 </span>

 {/* Checkmark */}
 {isSelected && (
 <div className="absolute top-1 right-1">
 <CheckCircle className="h-4 w-4 text-accent" />
 </div>
 )}
 </label>
 )
 })}
 </div>
 
 {error && (
 <p className="mt-2 text-sm text-red-600 dark:text-red-400">{error}</p>
 )}
 </div>
 )
}

